import React, { useEffect, useState } from 'react';
import {
  IconButton,
  Stack,
  TextField,
} from '@mui/material';
import { ConvertToEnglish } from 'utils/ConvertToEnglish';
import classes from 'Global/Styles/PersianSupport.module.scss';
import SuggestionBackdrop from 'Global/Components/CommonComponents/SuggestionBackdrop/SuggestionBackdrop';
import {
  AutoFixHigh,
  MicRounded,
} from '@mui/icons-material';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { useSpeechRecognition } from 'react-speech-recognition';
import useCustomSpeechRecognition from 'Global/Hooks/useCustomSpeechRecognition';
import useHandleSpeechRecognitionOutput from 'Global/Hooks/useHandleSpeechRecognitionOutput/useHandleSpeechRecognitionOutput';

const EditableTextArea = ({
  label,
  onChange,
  name,
  Initialvalue,
  errors,
  isEnglish = false,
  index,
  enableSuggest,
  element,
  isSmall = true,
  disabled,
  customOnChange = () => {},
  isMultiLine = false,
}) => {
  const [UiValue, setUiValue] = useState('');
  const [openBackdrop, setOpenSuggestBackdrop] =
    useState(false);

  useEffect(() => {
    setUiValue(Initialvalue);
    onChange && onChange(Initialvalue, index);
  }, [Initialvalue]);

  const [
    transcript,
    isListening,
    startListening,
    stopListening,
  ] = useHandleSpeechRecognitionOutput(UiValue, setUiValue);

  return (
    <React.Fragment>
      <SuggestionBackdrop
        openBackdrop={openBackdrop}
        setUiValue={setUiValue}
        element={element}
        setSuggestion={setOpenSuggestBackdrop}
        onChange={onChange}
      />
      <TextField
        rows={10}
        multiline={isMultiLine}
        disabled={disabled}
        {...(isSmall && { size: 'small' })}
        dir={!isEnglish ? 'rtl' : 'ltr'}
        label={label}
        value={UiValue ?? ''}
        error={errors && !!errors[name]}
        helperText={
          errors && errors[name]
            ? `فیلد ${label} را پرکنید`
            : ''
        }
        fullWidth
        onChange={(event) => {
          customOnChange && customOnChange(event);
          try {
            setUiValue(
              ConvertToEnglish(event.target.value)
            );
            onChange &&
              onChange(
                ConvertToEnglish(event.target.value),
                index
              );
          } catch (err) {}
        }}
        color="colorPrimer"
        InputLabelProps={
          !isEnglish
            ? {
                classes: {
                  root: classes.textFieldroot,
                  shrink: classes.textFieldShrink,
                },
              }
            : {}
        }
        InputProps={{
          startAdornment: enableSuggest ? (
            <Stack direction="column">
              <IconButton
                sx={{
                  '& svg': {
                    fill: `${themeColors.ColorPrimary} !important`,
                  },
                  transform: 'scale(.7)',
                  padding: '.1em',
                }}
                onClick={() => {
                  if (enableSuggest instanceof Array) {
                    setOpenSuggestBackdrop(true);
                  }
                }}
              >
                <AutoFixHigh color="primary" />
              </IconButton>
              <IconButton
                sx={{
                  '& svg': {
                    fill: isListening
                      ? 'red !important'
                      : `${themeColors.ColorPrimary} !important`,
                  },
                  transform: 'scale(.7)',
                  padding: '.1em',
                  transition: 'all .5s ease',
                }}
                onClick={() => {
                  if (isListening) {
                    stopListening();
                  } else {
                    startListening();
                  }
                }}
              >
                <MicRounded color="primary" />
              </IconButton>
            </Stack>
          ) : null,
        }}
      />
    </React.Fragment>
  );
};

export default EditableTextArea;
